import React from 'react';
import {
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    CardContent,
    Typography
} from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';

const DateRangeFilter = ({
    fromDate,
    toDate,
    dateType,
    status,
    setFromDate,
    setToDate,
    setDateType,
    setStatus
}) => {
    return (
        <Grid item xs={12}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Filters
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                label="From Date"
                                type="date"
                                value={fromDate}
                                onChange={e => setFromDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                label="To Date"
                                type="date"
                                value={toDate}
                                onChange={e => setToDate(e.target.value)}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <ToggleButtonGroup
                                value={dateType}
                                exclusive
                                onChange={(e, newValue) => {
                                    if (newValue !== null) {
                                        setDateType(newValue);
                                    }
                                }}
                                size="small"
                                fullWidth
                            >
                                <ToggleButton value="activityStart">Activity Start</ToggleButton>
                                <ToggleButton value="bookedOn">Booked On</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth>
                                <InputLabel>Status</InputLabel>
                                <Select value={status} onChange={e => setStatus(e.target.value)}>
                                    <MenuItem value="all">All</MenuItem>
                                    <MenuItem value="confirmed">Confirmed</MenuItem>
                                    <MenuItem value="unconfirmed">Unconfirmed</MenuItem>
                                    <MenuItem value="cancelled">Cancelled</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default DateRangeFilter;
